module.exports = __webpack_public_path__ + "img/30_newYouth_zw.46ade20b.png";